/**
 * Caasi Blog — Mobile Sticky Bar (mobile_sticky_bar.js)
 *
 * Gedrag:
 * - Verschijnt als de gebruiker 30% van de pagina heeft gescrollt
 * - Verdwijnt als de gebruiker omhoog scrollt, verschijnt weer bij omlaag scrollen
 * - X-knop slaat een vlag op in sessionStorage zodat de balk permanent gesloten blijft
 *   voor de rest van de sessie (verdwijnt bij nieuw tabblad / nieuwe sessie)
 */

(function () {
  'use strict';

  var BAR_ID           = 'caasi-mobile-bar';
  var CLOSE_BTN_ID     = 'caasi-mobile-bar-close';
  var STORAGE_KEY      = 'caasi_mobile_bar_closed';
  var VISIBLE_CLASS    = 'caasi-mobile-bar--visible';
  var SCROLL_THRESHOLD = 0.30; /* 30% van paginahoogte */

  var bar      = document.getElementById(BAR_ID);
  var closeBtn = document.getElementById(CLOSE_BTN_ID);

  if (!bar) return;

  /* Controleer of de gebruiker de balk al gesloten heeft in deze sessie */
  if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    bar.parentNode && bar.parentNode.removeChild(bar);
    return;
  }

  /* Schermbreedtecheck — op ≥768px doet JS niets (CSS verbergt al) */
  function isDesktop() {
    return window.innerWidth >= 768;
  }

  var lastScrollY    = window.pageYOffset;
  var isBarVisible   = false;
  var isClosed       = false;
  var rafPending     = false;

  function getScrollPercent() {
    var scrollTop  = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight  = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return 0;
    return scrollTop / docHeight;
  }

  function showBar() {
    if (isBarVisible || isClosed || isDesktop()) return;
    isBarVisible = true;
    bar.classList.add(VISIBLE_CLASS);
    bar.setAttribute('aria-hidden', 'false');
  }

  function hideBar() {
    if (!isBarVisible) return;
    isBarVisible = false;
    bar.classList.remove(VISIBLE_CLASS);
    bar.setAttribute('aria-hidden', 'true');
  }

  function onScroll() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      if (isClosed || isDesktop()) return;

      var currentScrollY  = window.pageYOffset;
      var scrollPercent   = getScrollPercent();
      var scrollingDown   = currentScrollY > lastScrollY;

      if (scrollPercent >= SCROLL_THRESHOLD) {
        if (scrollingDown) {
          showBar();
        } else {
          /* Omhoog scrollen: verberg de balk tijdelijk */
          hideBar();
        }
      } else {
        hideBar();
      }

      lastScrollY = currentScrollY;
    });
  }

  function onClose(e) {
    e.preventDefault();
    isClosed = true;
    sessionStorage.setItem(STORAGE_KEY, '1');
    hideBar();
    /* Verwijder uit DOM na transitie */
    bar.addEventListener('transitionend', function onEnd() {
      bar.removeEventListener('transitionend', onEnd);
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });
  }

  /* Event listeners */
  window.addEventListener('scroll', onScroll, { passive: true });

  if (closeBtn) {
    closeBtn.addEventListener('click', onClose);
  }

  /* Initiaal check (bij directe link naar ankerpunt kan pagina al gescrollt zijn) */
  onScroll();
})();
